import { render, staticRenderFns } from "./CheckoutMobile.vue?vue&type=template&id=33987ef4&scoped=true"
import script from "./CheckoutMobile.vue?vue&type=script&lang=js"
export * from "./CheckoutMobile.vue?vue&type=script&lang=js"
import style0 from "./CheckoutMobile.vue?vue&type=style&index=0&id=33987ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33987ef4",
  null
  
)

export default component.exports